var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"movingImage",attrs:{"src":require(`@/assets/img/float_${_vm.icon}.png`),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }